import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import CommonButtonLink from '../../../components/common-button-link/CommonButtonLink';
import WithLabel, { LABEL_STYLES } from '../../../components/with-label/WithLabel';
import dayjs from '../../../utils/dateUtils';
import isDefined from '../../../utils/isDefined';

import scss from './MessageInfoModal.module.scss';

const DetailsTab = ({ selector, onOpenImages }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation('scout');

  const { createdOn, createdBy, count, original } = useSelector(selector)?.messageLogs?.original ?? {};
  const imagesPromptCount = useSelector(selector)?.messageLogs?.imagesPromptCount;

  const formattedCreatedOn = useMemo(() => {
    if (!createdOn) {
      return '-/-';
    }

    return dayjs(createdOn, 'MMM DD, YYYY HH:mm:ss').locale(language).format('LL');
  }, [createdOn, language]);

  const handleOpenImages = () => {
    onOpenImages();
  };

  return (
    <div className={scss.detailsList}>
      <WithLabel variant={LABEL_STYLES.CUSTOM} label={`${t('createdOn')}:`} extraClassName={scss.detailRow}>
        <span>{formattedCreatedOn}</span>
      </WithLabel>
      <WithLabel variant={LABEL_STYLES.CUSTOM} label={`${t('createdBy')}:`} extraClassName={scss.detailRow}>
        <span>{createdBy || '-/-'}</span>
      </WithLabel>
      <WithLabel variant={LABEL_STYLES.CUSTOM} label={'ID:'} extraClassName={scss.detailRow}>
        <span>{count || '-/-'}</span>
      </WithLabel>
      {isDefined(imagesPromptCount) ? (
        <WithLabel variant={LABEL_STYLES.CUSTOM} label={`${t('imagesCount')}:`} extraClassName={scss.detailRow}>
          {onOpenImages && Number(imagesPromptCount) > 0 ? (
            <CommonButtonLink styleColor='stressed' onClick={handleOpenImages}>
              {imagesPromptCount}
            </CommonButtonLink>
          ) : (
            <span>{imagesPromptCount}</span>
          )}
        </WithLabel>
      ) : null}
      <WithLabel variant={LABEL_STYLES.CUSTOM} label={`${t('original')}:`} extraClassName={scss.detailRow}>
        <pre className={scss.originalText}>{original || '-/-'}</pre>
      </WithLabel>
    </div>
  );
};

export default memo(DetailsTab);
